import React from 'react';
import { Table } from 'react-bootstrap';

const getFlagImageUrl = (imagePath) => {
  if (!imagePath) return null;

  if (imagePath.startsWith('http')) {
    return imagePath;
  }

  return `https://api.soksan-dss.com/uploads/flag/${imagePath}`;
};

const getFallbackFlag = (languageName) => {
  const flags = {};

  return flags[languageName] || 'Flag';
};

const LanguageWiseUserTable = ({ languageData = [] }) => {
  const topLanguages = React.useMemo(() => {
    if (!languageData || !Array.isArray(languageData)) return [];

    return [...languageData]
      .filter((item) => item && item.UserCount > 0)
      .sort((a, b) => b.UserCount - a.UserCount)
      .slice(0, 5)
      .map((item, index) => ({
        ...item,
        rank: index + 1,
        flagUrl: getFlagImageUrl(item.ImageOfFlag),
        fallbackFlag: getFallbackFlag(item.LanguageName),
      }));
  }, [languageData]);

  const headerStyle = {
    backgroundColor: '#E8F5E9',
    color: '#1B5E20',
    fontWeight: 'bold',
    padding: '8px 12px',
    fontSize: '13px',
  };

  const viewsStyle = {
    color: '#1B5E20',
    fontWeight: '500',
  };

  const cellStyle = {
    padding: '8px 12px',
    fontSize: '13px',
    border: 'none',
  };

  return (
    <div className="col-12 col-md-6 col-xl-3">
      <div className="card h-100">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6
              style={{
                color: '#1B5E20',
                fontWeight: 'bold',
                fontSize: '14px',
                margin: 0,
              }}
            >
              Top Languages
            </h6>
          </div>

          <div
            style={{
              border: '1px solid #C8E6C9',
              borderRadius: '5px',
              overflow: 'hidden',
            }}
          >
            <Table responsive hover className="mb-0" style={{ margin: '0' }}>
              <thead>
                <tr>
                  <th style={{ ...headerStyle, width: '70%' }}>Language</th>
                  <th className="text-end" style={{ ...headerStyle, width: '30%' }}>
                    Users
                  </th>
                </tr>
              </thead>

              <tbody>
                {topLanguages.length === 0 ? (
                  <tr>
                    <td
                      colSpan="3"
                      style={{
                        ...cellStyle,
                        textAlign: 'center',
                        color: '#999',
                        fontStyle: 'italic',
                      }}
                    >
                      No language data available
                    </td>
                  </tr>
                ) : (
                  topLanguages.map((item, index) => (
                    <tr key={item.LanguageID || index}>
                      <td style={cellStyle}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              width: '24px',
                              height: '16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            {item.flagUrl ? (
                              <img
                                src={item.flagUrl}
                                alt={item.LanguageName}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  borderRadius: '2px',
                                  border: '1px solid #ddd',
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = 'none';
                                  e.target.parentElement.innerHTML = `
                                    <div style="font-size: 12px;">${item.fallbackFlag}</div>
                                  `;
                                }}
                              />
                            ) : (
                              <div style={{ fontSize: '12px' }}>{item.fallbackFlag}</div>
                            )}
                          </div>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '100%',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {item.LanguageName}
                          </span>
                        </div>
                      </td>

                      <td className="text-end" style={{ ...cellStyle, ...viewsStyle }}>
                        {item.UserCount}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

LanguageWiseUserTable.defaultProps = {
  languageData: [],
};

export default LanguageWiseUserTable;
